import { useMutation } from "@tanstack/react-query";
import React, { useContext, useState } from "react";

//Snackbar
import Snackbar from "../../common/VFX-UI/SnackBar/Snackbar";

//App
import StateForm from "./StateForm";
//import { StateFormContainerProps } from "../../../types";
import { StatesContext } from "./StatesContainer";
import stateApi from "../../../app/model/api/stateApi";
import { EMPTY_GUID } from "../../../utility/constants/constants";
import { StateViewModel } from "../../../viewModels/stateViewModel";
import { StateDto } from "../../../app/model/api/types/dto/stateDto";
import { apiErrorMessage } from "../../../utility/lib/error";
import { SnackbarState } from "../../../types";
import { StateFormContainerProps } from "../../../types/state";

export const StateFormContainer = ({
  onClose,
  onShowSuccess,
}: StateFormContainerProps) => {
  const stateContext = useContext(StatesContext);
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = stateContext?.id
    ? "Setting updated"
    : "New Setting added";

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const { status, mutate } = useMutation<void, Error, StateDto>({
    mutationFn: async (payload: StateDto) => {
      const response = await stateApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
    onError: () => console.log("error"),
    onSuccess: () => console.log("success"),
  });

  const handleOnSubmitHandler = async (values: StateViewModel) => {
    const State: StateDto = values.toDto();
    if (Array.isArray(State.regionId) && State.regionId.length > 0) {
      State.regionId = State.regionId[0];
    }
    State.isDeleted = false;
    mutate(State);
  };

  const initialValues = stateContext?.id
    ? new StateViewModel(
        stateContext.data?.id ?? null,
        stateContext.data?.name ?? null,
        stateContext.data?.description ?? null,
        stateContext.data?.abbreviation ?? null,
        stateContext.data?.capital ?? null,
        stateContext.data?.regionId != null &&
        stateContext.data?.regionId !== undefined
            ? [stateContext.data?.regionId]
            : null,
        stateContext.data?.sortValue ?? null,
        stateContext.data?.isActive ?? null
      )
    : new StateViewModel(EMPTY_GUID, null, null, null, null, null, 100, true);

  return (
    <>
      <StateForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmitHandler}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
